import { Component, NgModule, ViewChild } from '@angular/core';
import { CignalService } from '../cignal.service';
import { GlobalService } from '../global.service';
import { Router } from '@angular/router';
import { FilterSearchBarComponent } from '../reusables/filter-search-bar/filter-search-bar.component';
import { TpUsernameFilterComponent } from '../reusables/tp-username-filter/tp-username-filter.component';
import { DateRangePickerComponent } from '../reusables/date-range-picker/date-range-picker.component';
import { ClassificationFilterComponent } from '../reusables/classification-filter/classification-filter.component';
import { Sort } from '@angular/material/sort';
import { MobileTableSortComponent } from '../reusables/mobile-table-sort/mobile-table-sort.component';
import { SelloutService } from '../services/sell-out/sell-out.service';
@Component({
  selector: 'app-sell-out',
  templateUrl: './sell-out.component.html',
  styleUrls: ['./sell-out.component.css']
})
export class SellOutComponent {

  @ViewChild(FilterSearchBarComponent) 
  private SearchBar!:FilterSearchBarComponent;
  @ViewChild(TpUsernameFilterComponent) 
  private tpUsernameFilter!:TpUsernameFilterComponent;
  @ViewChild(DateRangePickerComponent) 
  private dateRangePicker!:DateRangePickerComponent;
  @ViewChild(ClassificationFilterComponent) 
  private classificationFilter!:ClassificationFilterComponent;
  @ViewChild(MobileTableSortComponent) 
  private mobileTableSortComponent!:MobileTableSortComponent;

  constructor(
    private cignalService: CignalService,
    public globalService: GlobalService,
    private router: Router,
    private sellOutServices: SelloutService,
  ){}
  
  isMobile : boolean = false;
  sellOutData : Array<any> = [];
  currentTab = "tp";
  requestID : number = 0;
  requestTotalID : number = 0;

  isLoading : boolean = false;
  // isTotalLoading : boolean = false;
  message : any = "";

  sort_order : string = '';
  sort_by : string = '';

  requestParam:any = {};
  itemsPeraPage = 15;

  ngOnInit(){
    this.isMobile = this.globalService.isMobile();
    this.requestParam.limit = this.itemsPeraPage;
    this.requestParam.criteria = {};
    this.getSellOutData();
  }

  // PAGINATION
  current_page = 1;
  total_page = 1;
  updateSellInRecordPage(page:number){
    this.current_page = page;
    this.requestParam.offset = (this.current_page - 1) * this.itemsPeraPage;
    this.getSellOutData();
  }

  // SEARCH FILTER
  searchValue:string = "";
  updateSearchValue(keyWord:string){
    
    this.current_page = 1;
    delete this.requestParam.offset;

    this.searchValue = keyWord;
    this.requestParam.search_term = this.searchValue;
    
    this.getSellOutData()
  }

  // SELL-IN FILTER
  sellOutFilter : any = {};
  
  // TP NAME FILTER
  updateTpNameFilter(newTpName:string){
    this.requestParam.criteria.tp = newTpName.trim();
    if (!this.requestParam.criteria.tp) {
      delete this.requestParam.criteria.tp;  
    }
    this.current_page = 1;
    delete this.requestParam.offset;
    this.getSellOutData();
  }
  
  // DATE RANGE FILTER
  updateDateRangeFilter(newDateRangeFilter:any){

    this.clearSearch();
    
    delete this.requestParam.criteria.from_date;
    delete this.requestParam.criteria.to_date;

    if (typeof newDateRangeFilter.start_date === 'object') {
      this.requestParam.criteria.from_date = this.globalService.formatNgbDateStructToString(newDateRangeFilter.start_date);      
    }
    if (typeof newDateRangeFilter.end_date === 'object') {
      this.requestParam.criteria.to_date = this.globalService.addOneDayToEndDate(newDateRangeFilter.end_date);      
    }

    this.current_page = 1;
    this.getSellOutData();
  
  }
  
  // CLASSIFICATION FILTER
  updateClassificationFilter(newClassification:string){
    this.requestParam.criteria.seller_level = newClassification.trim();
    if (!this.requestParam.criteria.seller_level) {
      delete this.requestParam.criteria.seller_level;  
    }
    this.current_page = 1;
    this.getSellOutData();

  }
  updateClassificationFilterItems(){
    switch (this.currentTab) {
      case 'tp':
        return [
          ["TP","DEALER"],
          ["DEALER","SUBDEALER"],
          ["SUBDEALER","RETAILER"],
          ["RETAILER","RETAILER2"],
        ];
      case 'dealer':
        return [
          ["DEALER","SUBDEALER"],
          ["SUBDEALER","RETAILER"],
          ["RETAILER","RETAILER2"],
        ];
      case 'subdealer':
        return [
          ["SUBDEALER","RETAILER"],
          ["RETAILER","RETAILER2"],
        ];
      case 'retailer':
        return [];
      default:
        return [];
    }
  }

  //  CLEAR SEARCH AND FILTERS
  clearFilters(){
    this.tpUsernameFilter.clearTpNameFilter();
    this.dateRangePicker.clearDateRange();
    if (this.classificationFilter) {
      this.classificationFilter.clearClassificationFilter();
    }
    this.requestParam.criteria = {};
  }

  clearSearch(){
    this.SearchBar.clearSearch();
    this.searchValue = "";
    delete this.requestParam.search_term;
  }

  clearAllFilters(){
    this.clearSearch();
    this.clearFilters();
    this.current_page = 1;
    this.getSellOutData();
  }

  // EXPORT
  async exportSellOutRecord(){
    this.message = "";
    
    var result = await this.cignalService.exportSellOutData(this.requestParam, this.currentTab);
            
    if (result) {
      if (result.success) {

        this.globalService.showSnackbar(result.message,"Ok");
        this.router.navigateByUrl("/exports");
      
      }else{
        console.log(result.message);
        this.message = result.message;
      }
    }
  }

  // SELECT TAB
  selectTab(tabName:string){
    if (this.currentTab != tabName) {
      this.currentTab = tabName;
      this.clearFilters();
      this.clearSearch();
      if (this.isMobile) {
        this.mobileTableSortComponent.clearSort();
      }
      this.updateSort({direction:'',active:''});
      
      delete this.requestParam.offset;
      this.current_page = 1;
      this.total_page = 1;
      
      this.getSellOutData();
    }
  }

  // SORT SECTION
  updateSortMenuItem(){
    switch (this.currentTab) {
      case 'tp':
        return [
          ['Territorial Partner','tp_username'],
          ['e-Pins Denoms','product_name'],
          ['Amount','amount'],
          ['Date','create_date'],
          ['Name','name'],
          ['Classification','classification'],
          ['Subscriber','subscriber'],
        ];
      case 'dealer':
        return [
          ['Dealer','dealer_username'],
          ['Territorial Partner','tp_username'],
          ['e-Pins Denoms','product_name'],
          ['Amount','amount'],
          ['Date','create_date'],
          ['Name','name'],
          ['Classification','classification'],
          ['Subscriber','subscriber'],
        ];
      case 'retailer':
        return [
          ['Retailer','retailer_username'],
          ['Dealer','dealer_username'],
          ['Territorial Partner','tp_username'],
          ['e-Pins Denoms','product_name'],
          ['Amount','amount'],
          ['Date','create_date'],
          ['Subscriber','subscriber'],
        ];
        
        break;
      default:
        return [];
    }
  }
  updateSort(sort:Sort){
    if (sort.direction) {
      this.requestParam.sort_order = sort.direction;
      this.requestParam.sort_by = sort.active;
    }else{
      this.requestParam.sort_order = "";
      this.requestParam.sort_by = "";
    }
    this.getSellOutData();
  }

  // GET SELL OUT DATA
  async getSellOutData(){
    this.message = "";
    this.isLoading = true;
    // var itemsPerPage = this.isMobile ? 5 : 15 ;
    // var dataOffset = (this.current_page*itemsPerPage)-itemsPerPage;
    this.sellOutData = [];
    this.requestID += 1;
    var requestID = this.requestID;

    var result = await this.sellOutServices.getSellOutData(this.requestParam, this.currentTab);
    this.mountData(result, requestID);
    
    
  }
  mountData(result: any, requestID: number){
    if (this.requestID == requestID) {
      if(result){
        if (result.message) {
          this.message = result.message;
        }else{
          this.sellOutData = result.items;
          this.total_page = Math.ceil(result.total / this.itemsPeraPage);
          // if((result.total % itemsPerPage) == 0){
          //   this.total_page = Math.floor(result.total / itemsPerPage );
          // }else{
          //   this.total_page = Math.floor(result.total / itemsPerPage ) + 1;
          // }
        }
      }
      
      if (this.sellOutData.length == 0 && !this.message) {
        this.message = 'No item available.'
      }
      this.isLoading = false;
    }
  }

  // GET TOTAL SELL OUT DATA
  // async getSellOutTotalData(){
  //   var itemsPerPage = this.isMobile ? 5 : 15 ;
  //   var dataOffset = (this.current_page*itemsPerPage)-itemsPerPage;

    
  //   this.requestTotalID += 1;
  //   var requestTotalID = this.requestTotalID;

  //   if (this.searchValue) {
  //     switch (this.currentTab) {
  //       case 'tp':

  //         var result = await this.sellOutServices.searchSellOutTpTotal( this.searchValue)
  //         this.mountDataTotal(result, itemsPerPage, requestTotalID);
          
  //         break;
  //       case 'dealer':
          
  //         var result = await this.sellOutServices.searchSellOutDealerTotal( this.searchValue )
  //         this.mountDataTotal(result, itemsPerPage, requestTotalID);

  //         break;
  //       case 'retailer':

  //       var result = await this.sellOutServices.searchSellOutRetailerTotal( this.searchValue )
  //       this.mountDataTotal(result, itemsPerPage, requestTotalID);
        
  //         break;
  //       default:
  //         break;
  //       }
  //   }
  //   else if (Object.keys(this.sellOutFilter).length > 0) {
  //     var jsonFilter = this.formatFilterJson(this.sellOutFilter, itemsPerPage, dataOffset, this.sort_order, this.sort_by);
  //     switch (this.currentTab) {
  //       case 'tp':

  //         var result = await this.sellOutServices.filterSellOutTpTotal(jsonFilter);
  //         this.mountDataTotal(result, itemsPerPage, requestTotalID);
          
  //         break;
  //       case 'dealer':

  //         var result = await this.sellOutServices.filterSellOutDealerTotal(jsonFilter);
  //         this.mountDataTotal(result, itemsPerPage, requestTotalID);

  //         break;
  //       case 'retailer':

  //         var result = await this.sellOutServices.filterSellOutRetailerTotal(jsonFilter);
  //         this.mountDataTotal(result, itemsPerPage, requestTotalID);

  //         break;
  //       default:
  //         break;
  //     }
  //   } 
  //   else {
  //     switch (this.currentTab) {
  //       case 'tp':

  //         var result = await this.sellOutServices.getSellOutTpTotalRecord();
  //         this.mountDataTotal(result, itemsPerPage, requestTotalID);
          
  //         break;
  //       case 'dealer':

  //         var result = await this.sellOutServices.getSellOutDealerTotalRecord();
  //         this.mountDataTotal(result, itemsPerPage, requestTotalID);

  //         break;
  //       case 'retailer':
          
  //         var result = await this.sellOutServices.getSellOutRetailerTotalRecord();
  //         this.mountDataTotal(result, itemsPerPage, requestTotalID);

  //         break;
  //       default:
  //         break;
  //     }
  //   }
  // }
  // mountDataTotal(result: any, itemsPerPage: number, requestTotalID: number){
  //   if (this.requestTotalID == requestTotalID) {
  //     if(result){
  //       if (result.message) {
  //         this.message = result.message;
  //       }else{
  //         // this.sellOutData = result.items;
  //         if((result.total % itemsPerPage) == 0){
  //           this.total_page = Math.floor(result.total / itemsPerPage );
  //         }else{
  //           this.total_page = Math.floor(result.total / itemsPerPage ) + 1;
  //         }
  //       }
  //     }
    
  //     this.isTotalLoading = false;
  //   }
  // }

  // JSON FILTER
  formatFilterJson(filterJson : any, limit: number, offset: number, sort_order: string, sort_by : string){

    var filter : any = {};
    if (filterJson.tpNameFilter) { 
      filter.tp_username = filterJson.tpNameFilter;
    }
    if (filterJson.classification) { 
      filter.classification = filterJson.classification;
    }
    if (filterJson.end_date) { 
      filter.to_date = filterJson.end_date;
    }
    if (filterJson.start_date) {
      filter.from_date = filterJson.start_date;
    }
    if (sort_order && sort_by) {
      filter.sort_order = sort_order;
      filter.sort_by = sort_by;
    }

    filter.limit = limit;
    filter.offset = offset;

    return filter;
  }

  // SHOW/HIDE MOBILE VIEW FILTER
  showFilter(val:boolean){
    let sidebar = document.getElementById("filter_div") as HTMLElement;
    if (sidebar) {
      var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      console.log(width);
      if (width < 600) {
        if (val) {
          sidebar.style.display = "flex";
        }else{
          sidebar.style.display = "none";
        } 
      }
    }
  }

}

